import { Controller } from "@hotwired/stimulus"

// data-controller="force-focus"
export default class extends Controller {
  static values = {
    selector: String,
    ignoreSelector: {
      type: String,
      default: "input, select, option, textarea, button, a, label, [role='listbox'], [role='option']"
    }
  }

  connect() {
    this.onPointerDown = (e) => this.handlePointerDown(e)
    this.onFocusIn = (e) => this.handleFocusIn(e)
    this.onChange = (e) => this.handleChange(e)

    // ✅ 문서 전체를 막지 말고, 폼 영역(this.element)에서만 감시
    this.element.addEventListener("pointerdown", this.onPointerDown, true)
    this.element.addEventListener("focusin", this.onFocusIn, true)
    this.element.addEventListener("change", this.onChange, true)

    this.focus()
  }

  disconnect() {
    this.element.removeEventListener("pointerdown", this.onPointerDown, true)
    this.element.removeEventListener("focusin", this.onFocusIn, true)
    this.element.removeEventListener("change", this.onChange, true)
  }

  handlePointerDown(event) {
    // 폼 컨트롤 조작 중에는 검색 입력으로 포커스를 빼앗지 않는다.
    if (event.target.closest(this.ignoreSelectorValue)) return

    this.focus()
  }

  handleFocusIn(event) {
    // 폼 컨트롤 조작 중에는 검색 입력으로 포커스를 빼앗지 않는다.
    if (event.target.closest(this.ignoreSelectorValue)) return

    const target = this.getTarget()
    if (target && event.target !== target) this.focus()
  }

  handleChange(event) {
    if (event.target.closest(this.ignoreSelectorValue)) return

    this.focus()
  }

  getTarget() {
    return document.querySelector(this.selectorValue)
  }

  focus() {
    requestAnimationFrame(() => {
      this.getTarget()?.focus({ preventScroll: true })
    })
  }
}
